// 构建变量配置
const buildConfig = (variable, ext = {}) => {
  return {
    label: variable, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: variable, // 确认后输入的内容
    ...ext
  }
}
/**
 * 官方内部变量
 * @author Caesar Liu
 * @date 2020-11-20 17:42
 */
module.exports = [
  buildConfig('.now', { documentation: '当前时间' }),
  buildConfig('.version', { documentation: '当前freemarker版本' })
]
